import axios from 'axios';
import { jwtDecode } from 'jwt-decode';

import { AppEndpointKeys } from '../../utils/constants/AppEndpoint';
import { getAuthorizerHeader } from '../../utils/helpers/httpHeaders';

export interface UserInformationResponse {
  accessToken: string;
  email: string;
  firstName: string;
  id: number;
  lastName: string;
  name: string;
  oId: string;
  roles: string[];
}

export const fetchUserInformation = async () => {
  const requestOptions = getAuthorizerHeader();

  if (requestOptions) {
    const url = `${AppEndpointKeys.AUTHORIZER}`;

    const { data } = await axios.post(url, {}, requestOptions);

    const token = data?.token ?? '';
    
    if (!token) {
      return null;
    }

    const decoded = jwtDecode<UserInformationResponse>(token);

    if (decoded) {
      return {
        accessToken: decoded.accessToken,
        email: decoded.email,
        firstName: decoded.firstName,
        id: decoded.id,
        lastName: decoded.lastName,
        name: decoded.name,
        oId: decoded.oId,
        roles: decoded.roles || [],
      } as UserInformationResponse;
    }
  }

  return null;
};
